import { render, staticRenderFns } from "./HelpDoc.vue?vue&type=template&id=2effea24&scoped=true"
import script from "./HelpDoc.vue?vue&type=script&lang=js"
export * from "./HelpDoc.vue?vue&type=script&lang=js"
import style0 from "./HelpDoc.vue?vue&type=style&index=0&id=2effea24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2effea24",
  null
  
)

export default component.exports